// extracted by mini-css-extract-plugin
export default {"container":"_9Jpt3","header":"raj+8","closeIcon":"UFb74"};